import React from "react";
import { useHistory } from "react-router";
import { Collection } from "./Collection";
import { Product } from "../../../../core/types/entities";
import { useTranslation } from "react-i18next";

type CollectionsGroupProps = {
  collection: Product;
};

export const CollectionsGroup = ({ collection }: CollectionsGroupProps) => {
  const history = useHistory();
  const { t } = useTranslation();
  const handleShowAll = () => {
    history.push(`/products/${collection.id}`);
  };

  const handleShowCollection = () => {
    history.push(`/products/${collection.id}`);
  };

  return (
    <div className="flex flex-col gap-1.5">
      <div className="grid grid-rows-2 grid-cols-2 overflow-hidden rounded-[var(--collections-radius)] h-[var(--collections-size)] w-[var(--collections-size)]">
        {collection.images.map((image, i) => (
          <Collection key={i} image={image.src} onClick={handleShowCollection} />
        ))}
        <div
          onClick={handleShowAll}
          className="flex-1 place-content-center text-center bg-[var(--collection-show-all-bg-color)] min-h-[var(--collection-size)] min-w-[var(--collection-size)] w-[var(--collection-size)] h-[var(--collection-size)]"
        >
          <span className="text-[var(--collection-show-all-text-color)] text-[0.625rem]">{t("All")}</span>
        </div>
      </div>
    </div>
  );
};
